import { render } from "./WagerUserMilestonesDialog.vue?vue&type=template&id=26d86b30&scoped=true"
import script from "./WagerUserMilestonesDialog.vue?vue&type=script&lang=js"
export * from "./WagerUserMilestonesDialog.vue?vue&type=script&lang=js"

import "./WagerUserMilestonesDialog.vue?vue&type=style&index=0&id=26d86b30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d86b30"]])

export default __exports__